import { render, staticRenderFns } from "./GradingReports.vue?vue&type=template&id=5aeb66f7&scoped=true&"
import script from "./GradingReports.vue?vue&type=script&lang=js&"
export * from "./GradingReports.vue?vue&type=script&lang=js&"
import style0 from "./GradingReports.vue?vue&type=style&index=0&id=5aeb66f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb66f7",
  null
  
)

export default component.exports